import React, { useEffect, useState } from 'react'
import styled from 'styled-components';

import { ReactComponent as CloseIcon } from "../../Assets/iconsv2/generic/closeBtn.svg";
import { useTranslate } from '@tolgee/react';
import { FormControlLabel } from '@mui/material';
import { IOSSwitch } from '../GenericComponents/CustomSwitch';
import BlockContactElement from './BlockContactElement';
import { useConversationService } from '../../Context/ConversationsContext';
import { useAuthService } from '../../Context/AuthContext';
import SearchMenu from '../GenericComponents/SearchMenu';

const BlockUsers = ({ handleClose, setLoading, handleBlockContact, handleUnblockContact }) => {

    const { user, handleLoginUser } = useAuthService();

    const {
        getBlockedContacts,
        blockUnknownContacts,
        getContacts: getPersonalContacts,
        getContactsOnPlatformForCurrentUser: getPlatformContacts
    } = useConversationService();

    const [blockedContacts, setBlockedContacts] = useState([]);
    const [unblockedContacts, setUnblockedContacts] = useState([]);
    const [blockUnknownContacs, setBlockUnknownContacts] = useState(user.block_unknown_users)

    const [searchInput, setSearchInput] = useState("");

    const getContacts = () => {
        setLoading(true);

        Promise.all([
            new Promise((resolve) => getBlockedContacts((res) => resolve(res.data), () => resolve({}))),
            new Promise((resolve) => getPersonalContacts((res) => resolve(res.data), () => resolve({}))),
            new Promise((resolve) => getPlatformContacts((res) => resolve(res.data), () => resolve({})))
        ]).then(([blockedData, personalData, platformData]) => {

            const blockedList = blockedData.contacts || [];
            const blockedIds = new Set(blockedList.map(c => c.id));
            const personalList = personalData.contacts || [];
            const platformList = [
                ...(platformData.contacts || []),
                ...(platformData.users || []),
                ...(platformData.business_contacts || []),
                ...(platformData.organization_contacts || [])
            ];
            const uniqueUsers = new Map();
            [...personalList, ...platformList].forEach(user => {
                if (user && user.id) {
                    uniqueUsers.set(user.id, user);
                }
            });

            const allUsers = Array.from(uniqueUsers.values());
            const blocked = allUsers.filter(user => blockedIds.has(user.id));
            const unblocked = allUsers.filter(user => !blockedIds.has(user.id));
            const sorter = (a, b) => (a.name || a.email || "").toLowerCase() > (b.name || b.email || "").toLowerCase() ? 1 : -1;

            setBlockedContacts(blocked.sort(sorter));
            setUnblockedContacts(unblocked.sort(sorter));
            setLoading(false);
        }).catch(err => {
            console.error("Error fetching contacts:", err);
            setLoading(false);
        });
    };

    const searchMember = (list) => {
        if (searchInput === "") {
            return list;
        }
        return list.filter((item) => (item.name || item.email || "").toLowerCase().includes(searchInput?.toLowerCase()));
    }

    const handleBlock = (contact) => {
    handleBlockContact(contact,
            () => {
                getContacts();
            }
        )
    }

    const handleUnblock = (contact) => {
        handleUnblockContact(contact,
            () => {
                getContacts();
            })
    }

    const handleBlockUnknownContacts = (block) => {
        blockUnknownContacts(
            block,
            (response) => {
                handleLoginUser(response.data.user)
                setBlockUnknownContacts(response.data.user.block_unknown_users)
            },
            (error) => {
                console.log(error)
            }
        )
    }

    useEffect(() => {
        getContacts()
    }, [])

    const { t } = useTranslate();

    return (
        <FullScreenItem>
            <BlockUsersContainer>

                <Container>
                    <div style={{ width: "100%", display: "flex", justifyContent: "end" }}></div>

                    <ProfileTitle>
                        <h1>{t('profile.block_users')}</h1>
                    </ProfileTitle>
                    <div style={{ width: "100%", display: "flex", justifyContent: "end" }}>
                        <BackButton onClick={() => handleClose(false)}>
                            <CloseIcon />
                        </BackButton>
                    </div>
                </Container>

                <Group>
                    <TitleWrapper>
                        <h1>{t('profile.unknown_users').toUpperCase()}</h1>
                    </TitleWrapper>
                    <OptionWrapper style={{ border: "none", padding: 0 }}>
                        <BlockUnknownUsers >
                            <p>{t('profile.block_unknown_users')}</p>
                            <FormControlLabel
                                style={{ margin: 0 }}
                                control={<IOSSwitch
                                    checked={blockUnknownContacs}
                                    onChange={(e) => handleBlockUnknownContacts(e.target.checked)}
                                />}
                            />
                        </BlockUnknownUsers>

                    </OptionWrapper>
                </Group>
                <Group>
                    <TitleWrapper>
                        <h1>{t('general.contacts')}</h1>
                    </TitleWrapper>
                    <SearchMenu
                        name='searchInput'
                        value={searchInput}
                        setvalue={setSearchInput}
                    />
                </Group>
                <Group style={{ overflow: "auto" }}>
                    {blockedContacts.length > 0 &&
                        <Group>
                            <TitleWrapper>
                                <h1>{t('block_contacts.blocked').toUpperCase()}</h1>
                            </TitleWrapper>
                            <OptionWrapper>
                                {searchMember(blockedContacts).map((contact, index) => (
                                    <BlockContactElement
                                        key={contact.id || index}
                                        item={contact}
                                        unblockContact={handleUnblock}
                                        blocked={true}
                                    />
                                ))}
                            </OptionWrapper>
                        </Group>
                    }

                    <Group>
                        <TitleWrapper>
                            <h1>{t('block_contacts.unblocked').toUpperCase()}</h1>
                        </TitleWrapper>
                        <OptionWrapper>
                            {searchMember(unblockedContacts).map((contact, index) => (
                                <BlockContactElement
                                    key={contact.id || index}
                                    item={contact}
                                    blockContact={handleBlock}
                                    blocked={false}
                                />
                            ))}
                        </OptionWrapper>
                    </Group>
                </Group>
            </BlockUsersContainer>
        </FullScreenItem >
    )
}

export default BlockUsers

const FullScreenItem = styled.div`
position:absolute;
top:0;
left:0;
right:0;
bottom:0;
background:rgba(0,0,0,0.3);
width:100%;
height:100%;
display:flex;
justify-content:center;
align-items:center;
z-index:2;
`

const BlockUsersContainer = styled.div`
display:flex;
flex-direction:column;
padding:25px;
height:90%;
width:100%;
max-width:644px;
background:${({ theme }) => theme.menu.background};
gap:25px;
border-radius:4px;
  overflow:hidden;
`;

const BackButton = styled.button`

  color: ${({ theme }) => theme.menu.primaryTextColor};
  font-size: 16px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: left;
  background: none;
  border: none;
  cursor: pointer;
  gap: 10px;
  display: flex;
  align-items: center;
  margin-left:auto;
  svg{
  height:26px;
  width:26px;
  color:${({ theme }) => theme.menu.selectedOpionBackground};
  stroke:${({ theme }) => theme.sidebar.borderColor};
  }
`;
const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

`;
const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  h1 {
  color: ${({ theme }) => theme.menu.secondaryTextColor};
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    text-transform: uppercase;
  }
`;
const ProfileTitle = styled.div`
width:100%;
  justify-content: center;
  display: flex;
  min-width:140px;
  h1 {
  color: ${({ theme }) => theme.menu.primaryTextColor};
    font-size: 20px;
    font-weight: 600;
    line-height: 20px;
  }
`;
const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  background: ${({ theme }) => theme.menu.background};

    overflow:auto;
    height:100%;
`;
const BlockUnknownUsers = styled.div`
display:flex;
gap:10px;
align-items:center;
padding:10px 0;
p {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    text-align: left;
  color: ${({ theme }) => theme.menu.primaryTextColor};
    width: 100%;
  }
`
